// extracted by css-extract-rspack-plugin
export default {"base":"Base-module__base__n4phA","shine":"Base-module__shine__OTnzc"};